import { Grid, Button } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import VCliente from "../VClientes"
import { useDispatch, useSelector } from "react-redux"
import { openModalRegistroClienteAction } from "../../../ducks/cotizadorDuck"
export const ModalFormClienteStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "600px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))
export const ModalFormCliente = () => {
    const { modalRegistroCliente } = useSelector(state => state.cotizador)
    const dispatch = useDispatch()
    const classes = ModalFormClienteStyle()
    const handleClose = () => {
        dispatch(openModalRegistroClienteAction({open: false}))
    }
    const handleOpen = () => {
        dispatch(openModalRegistroClienteAction({open: true}))
    }
    return (
        <>
            <Button variant="outlined" color="primary" onClick={handleOpen}>Nuevo cliente</Button>
            <ModalBase classes={classes} open={modalRegistroCliente} onClose={handleClose}>
                <HeaderModal handleClose={handleClose} titulo={`Nueva cliente`} />
                <Grid container className={classes.containerSpacing}>
                    <VCliente />
                </Grid>
            </ModalBase>
        </>
    )
}
export default ModalFormCliente